export const LOAD_PURCHASE_ORDERS = 'LOAD_PURCHASE_ORDERS'
export const ADD_PURCHASE_ORDER = 'ADD_PURCHASE_ORDER'